import { makeAutoObservable } from 'mobx'
import { createRevisionRequest, RevisionPrompt } from 'components/BlazeCommandLine/api/createRevisionRequest'
import { camelCase, mapKeys } from 'lodash'
import { Selection } from 'types'
import { Selection as ProseSelection } from 'prosemirror-state'

export interface RequestJson {
  id: number
  offset?: number
  selection: Selection | null
  prompt: { [key: string]: any }
  article_id: string
  layer_id: string
}

export interface IRevisionSuggestionRequest {
  tryAgain: (selection?: ProseSelection) => Promise<any>
  selection?: Selection | null
  offset?: number
}

export class RevisionSuggestionRequest implements IRevisionSuggestionRequest {
  id: number
  articleId: string
  layerId: string
  selection?: Selection | null
  offset?: number
  prompt: { [key: string]: any }

  constructor(json: RequestJson) {
    this.id = json.id
    this.selection = json.selection
    this.offset = json.offset
    this.articleId = json.article_id
    this.layerId = json.layer_id
    this.prompt = mapKeys(json.prompt, (_, k) => camelCase(k))
    makeAutoObservable(this)
  }

  tryAgain(selection?: ProseSelection) {
    return createRevisionRequest({
      articleId: this.articleId,
      layerId: this.layerId,
      prompt: this.prompt as RevisionPrompt,
      selection,
    })
  }
}
